import { Modal } from "@/components/renderbus-modal";
import { Form, Input } from "@renderbus/ui";
import { FormProps, ModalProps } from "antd";
import { ValidatorRule } from "rc-field-form/lib/interface";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export function ChangePasswordModal({
  modalProps,
  formProps,
}: {
  modalProps?: ModalProps;
  formProps?: FormProps;
}) {
  const { t } = useTranslation("error");
  const validateOldPassword: ValidatorRule["validator"] = (_, value) => {
    if (!value) {
      return Promise.reject(t("utils_validate_psw_empty"));
    }
    return Promise.resolve();
  };
  const validatePassword: ValidatorRule["validator"] = (_, value) => {
    if (!value) {
      return Promise.reject(t("utils_validate_psw_empty"));
    }
    if (/\s/.test(value)) {
      return Promise.reject(t("utils_validate_psw_without_space"));
    }
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,18}$/.test(value)) {
      return Promise.reject(t("utils_validate_psw_illegal"));
    }
    if (value === formProps?.form?.getFieldValue("password")) {
      return Promise.reject(t("user_com_modifyPsw_label_old_same"));
    }
    return Promise.resolve();
  };

  const validateNewPassword: ValidatorRule["validator"] = (_, value) => {
    if (!value) {
      return Promise.reject(t("utils_validate_psw_empty"));
    }
    if (value !== formProps?.form?.getFieldValue("newPassword")) {
      return Promise.reject(t("user_com_modifyPsw_label_new_differ"));
    }
    return Promise.resolve();
  };

  const { t: profileT } = useTranslation("profile");
  return (
    <Modal {...modalProps}>
      <FormWrapper>
        <Form {...formProps}>
          <Form.Item
            name="password"
            label={profileT("old_password")}
            rules={[{ validator: validateOldPassword }]}
          >
            <Input
              type="password"
              placeholder={profileT("please_enter_old_password")}
            />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label={profileT("new_password")}
            rules={[{ validator: validatePassword }]}
          >
            <Input
              type="password"
              placeholder={profileT("please_enter_new_password")}
            />
          </Form.Item>
          <Form.Item
            name="checkPass"
            label={profileT("confirm_new_password")}
            rules={[{ validator: validateNewPassword }]}
          >
            <Input
              type="password"
              placeholder={profileT("please_enter_password_again")}
            />
          </Form.Item>
        </Form>
      </FormWrapper>
    </Modal>
  );
}

const FormWrapper = styled.div`
  input {
    background: #2c2c31 !important;
  }
`;
